module.exports = __webpack_public_path__ + "img/step4b-mobile-fr.20cdc598.webp";